/** Mirrors dropit_backend/src/ads/constants.py surface and billing unit choices. */
export const AD_SURFACES = [
  { value: 'promo', label: 'App-open promo modal' },
  { value: 'home', label: 'Home carousel banner' },
  { value: 'subcategory', label: 'Sub-category banner' },
  { value: 'search', label: 'Search screen banner' },
  { value: 'offer', label: 'Offers banner' },
  { value: 'flash_sale', label: 'Flash sale banner' },
  { value: 'order', label: 'Order confirmation banner' },
  { value: 'search_result', label: 'Sponsored search result' },
  { value: 'push', label: 'Sponsored push notification' },
] as const;

export const AD_BILLING_UNITS = [
  { value: 'per_day', label: 'Per day' },
  { value: 'per_month', label: 'Per month' },
  { value: 'per_slot', label: 'Per slot' },
  { value: 'per_send', label: 'Per send' },
] as const;

export type AdSurface = (typeof AD_SURFACES)[number]['value'];
export type AdBillingUnit = (typeof AD_BILLING_UNITS)[number]['value'];
